import React, { ComponentProps, VFC } from 'react';

import { MovieAudioSettingPopupButtonContainer } from '@/scenarios/legacy-player/components/feature-player/ui/movie/movie-audio-setting-popup-button/container';

import { useSubtitles } from '../../hooks/use-subtitles';
import { useAudio } from '../../hooks/use-audio';

type Props = Omit<ComponentProps<typeof MovieAudioSettingPopupButtonContainer>, 'subtitles'>;

export const EpisodeAudioSettingsPopupButtonContainer: VFC<Props> = ({ contentId, ...props }) => {
    const { subtitles, forceSubtitle } = useSubtitles(contentId);
    const audioTracks = useAudio(contentId);

    return (
        <MovieAudioSettingPopupButtonContainer
            contentId={contentId}
            audioTracks={audioTracks}
            subtitles={subtitles || []}
            forceSubtitle={forceSubtitle}
            {...props}
        />
    );
};
